import { render, staticRenderFns } from "./IfSourceLastDatum.vue?vue&type=template&id=0613d574&"
import script from "./IfSourceLastDatum.vue?vue&type=script&lang=js&"
export * from "./IfSourceLastDatum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports